import { ChevronRight, Circle, CircleCheck } from "lucide-react";
import { Link } from "@/lib/nav";

import SectionCard from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";
import type { SetupChecklist } from "@buildpy/core/modules/dashboard/setup-checklist";

// 대시보드 「처음 설정」 — 덜 된 칸이 위, 칸마다 그 설정 화면으로 간다(다 되면 부르는 쪽이 안 그린다).
const SetupChecklistCard = ({ checklist }: { checklist: SetupChecklist }) => {
  const items = [...checklist.items].sort((a, b) => Number(a.done) - Number(b.done));
  return (
    <SectionCard
      aria-labelledby="dashboard-setup"
      data-testid="dashboard-setup"
      description={`${checklist.doneCount}/${checklist.items.length} 완료 · 다 끝내면 이 카드는 사라집니다`}
      title={<span id="dashboard-setup">처음 설정</span>}>
      <ul className="grid gap-2 md:grid-cols-2">
        {items.map((item) => (
          <li data-done={item.done ? "true" : "false"} data-testid={`dashboard-setup-${item.key}`} key={item.key}>
            <Link className="flex items-center gap-x-3 rounded-md px-2 py-2 hover:bg-muted" href={item.href}>
              {item.done ? (
                <CircleCheck aria-hidden className="size-5 shrink-0 text-primary" />
              ) : (
                <Circle aria-hidden className="size-5 shrink-0 text-muted-foreground" />
              )}
              <span className="flex min-w-0 flex-1 flex-col">
                <span className={cn("text-sm font-medium", item.done && "text-muted-foreground line-through")}>
                  {item.label}
                  <span className="sr-only">{item.done ? " (완료)" : " (해야 함)"}</span>
                </span>
                {!item.done && <span className="text-xs text-muted-foreground">{item.hint}</span>}
              </span>
              <ChevronRight aria-hidden className="size-4 shrink-0 text-muted-foreground" />
            </Link>
          </li>
        ))}
      </ul>
    </SectionCard>
  );
};

export default SetupChecklistCard;
